import { render } from "./typeahead.vue?vue&type=template&id=7450b8ac&scoped=true"
import script from "./typeahead.vue?vue&type=script&lang=js"
export * from "./typeahead.vue?vue&type=script&lang=js"

import "./typeahead.vue?vue&type=style&index=0&id=7450b8ac&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\BijouCRM\\src\\ui\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7450b8ac"]])

export default __exports__